import { UserInstrument } from '../models/user';
import { WithUserNamespace } from '../reducers/user';

interface StateWithUser extends WithUserNamespace {
    app?: {
        user?: {
            publicId: string;
            isAttendeeMember: boolean;
            email: string;
            firstName?: string;
            lastName?: string;
        };
    };
}

export const getUserId = <State extends StateWithUser>(state: State): string =>
    state.app?.user?.publicId ?? '';

/**
 * Determines if a user has an active membership subscription. This does not
 * guarantee that a Membership fee discount is applied to the Order. For that,
 * use `selectors/order.js:hasMemberDiscount`
 * @param {Object} state the application Redux state
 * @returns {Boolean} true when the user is subscribed to Membership as determined by hydration
 */
export const isAttendeeMember = <State extends StateWithUser>(
    state: State,
): boolean => state.app?.user?.isAttendeeMember ?? false;

export const isUserLoggedIn = <State extends StateWithUser>(
    state: State,
): boolean => {
    const user = state.app?.user;

    return !!(user && user.publicId);
};

export const getUserEmail = <State extends StateWithUser>(state: State) =>
    isUserLoggedIn(state) && state.app?.user?.email;

export const getUserFirstName = <State extends StateWithUser>(state: State) =>
    isUserLoggedIn(state) && state.app?.user?.firstName;

export const getUserLastName = <State extends StateWithUser>(state: State) =>
    isUserLoggedIn(state) && state.app?.user?.lastName;

export const getUserInstruments = <State extends WithUserNamespace>(
    state: State,
): Array<UserInstrument> => state.user?.userInstruments ?? [];
